import type { ExtendedEnum } from '@/types'
import { useI18n } from 'vue-i18n'

export interface EnumOption {
  label: string
  value: string
}

export function useEnumOptions() {
  const { t } = useI18n()

  return <T extends string>(options: ExtendedEnum<T>[], i18nKey: string): EnumOption[] =>
    options.map((option) => ({ value: option.id, label: t(`${i18nKey}.${option.id}`) }))
}
